<div class="modal-inner plannings">
    <div class="modal-inner-inner w-100">
        <h1 class="mb-0">{{ data.day | date: 'EEEE d MMMM yyyy' }}</h1>

        <h2>{{ data.user?.name }}</h2>

        <section class="pb-4">
            <b>Verlof</b>

            @for (leave of data.leaves; track leave.id) {
                <div class="d-flex align-items-center">
                    <div class="flex-fill">
                        {{ leave.begindate | date: 'EEE d MMM yyyy' }} t/m
                        {{ leave.enddate | date: 'EEE d MMM yyyy' }}

                        @if (leave.interval_week > 0) {
                            <br />
                            Herhalend op: {{ leave | leaveRepeatDays }}
                        }

                        <br />
                        <i class="fa-duotone {{ leave.hourtype | hourtypeIcon }}"></i>
                        {{ leave.hourtype | hourtype }} - &nbsp;{{ leave.begindate | date: 'HH:mm' }} -
                        {{ leave.enddate | date: 'HH:mm' }}
                        <br />
                        <i>{{ leave.comment }}</i>
                    </div>
                    @if (!readonly) {
                        <div>
                            <button (click)="deleteLeave(leave)" mat-icon-button color="warn">
                                <mat-icon class="fas fa-trash" />
                            </button>
                        </div>
                    }
                </div>
            }

            @if (data.afasLeave) {
                <div>
                    <i class="fa-regular {{ data.afasLeave.icon }}"></i> {{ data.afasLeave.description }} Vanaf:
                    {{ data.afasLeave.startDate | date: 'd MMMM HH:mm' }}{{ data.afasLeave.endDate ? ' t/m ' : '' }}
                    {{ data.afasLeave.endDate | date: 'd MMMM HH:mm' }}
                </div>
            }

            @if (!data.leaves.length && !data.afasLeave) {
                <div>{{ data.user?.name }} heeft geen verlof op {{ data.day | date: 'EEE d MMMM y' }}</div>
            }
        </section>
        <section>
            <b>Planning</b>

            @for (planning of data.userPlanning; track planning) {
                <div class="d-flex">
                    <div class="flex-fill">
                        <i
                            class="fa-duotone"
                            [class.fa-user-helmet-safety]="planning.afas_project_id"
                            [class.fa-users]="!planning.afas_project_id"></i>
                        &nbsp;{{ planning.begindate | date: 'HH:mm' }} t/m {{ planning.enddate | date: 'HH:mm' }} -
                        {{ planning.afas_project_id ?? planning?.planning?.afas_project_id }}

                        @if (data.showLinks !== false) {
                            @if (!environment.asphaltPlanning && planning.planning) {
                                @let weekYear = planning.begindate | date: 'w/YYYY';
                                <a
                                    href="/weekplanning/{{ weekYear }}/{{ planning.planning_id }}"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    ({{ environment.rootPageName }})
                                </a>
                            } @else if (!planning.afas_project_id) {
                                <a
                                    (click)="planningDetailDialogService.openPlanning(planning.planning)"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    ({{ environment.rootPageName }})
                                </a>
                            } @else if (planning.afas_project_id) {
                                <span>(personeelsplanning)</span>
                            }
                        }
                        <br />
                        {{ planning.planning?.project?.name ?? planning?.project?.name }}
                    </div>

                    @if (!readonly) {
                        <div>
                            <button (click)="deleteUserPlanning(planning)" mat-icon-button color="warn">
                                <mat-icon class="fas fa-trash" />
                            </button>
                        </div>
                    }
                </div>
            }

            @for (planning of data.planningHas; track planning) {
                <div class="d-flex">
                    <div class="flex-fill">
                        <i class="fa-duotone fa-truck"></i>
                        &nbsp;{{ planning.begindate | date: 'HH:mm' }} t/m {{ planning.enddate | date: 'HH:mm' }} -
                        {{ planning.afas_project_id ?? planning?.planning?.afas_project_id }}
                        <br />
                        {{ planning.planning?.project?.name ?? planning?.project?.name }}

                        @if (data.showLinks !== false && !environment.asphaltPlanning && planning.planning) {
                            @let weekYear = planning.begindate | date: 'w/YYYY';
                            <a
                                href="/weekplanning/{{ weekYear }}/{{ planning.planning_id }}"
                                target="_blank"
                                rel="noopener noreferrer">
                                ({{ environment.rootPageName }})
                            </a>
                        } @else if (data.showLinks !== false) {
                            <a
                                href="/transport-planning/{{ planning.begindate | date: 'yyyy-MM-dd' }}"
                                target="_blank"
                                rel="noopener noreferrer">
                                (transportplanning)
                            </a>
                        }
                    </div>
                    @if (!readonly) {
                        <div>
                            <button (click)="deletePlanningHas(planning)" mat-icon-button color="warn">
                                <mat-icon class="fas fa-trash" />
                            </button>
                        </div>
                    }
                </div>
            }

            @if (!data.userPlanning?.length && !data.planningHas?.length) {
                <div>{{ data.user?.name }} is niet ingepland op {{ data.day | date: 'EEE d MMMM yyyy' }}</div>
            }
        </section>
    </div>

    <div class="buttons mt-3">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Sluiten</button>
    </div>
</div>
